export default 
{
	"progressbar-page-title": "Pagina",
	"name-suffix": "Achtervoegsel",
	"fileupload-desc-progress-message": "Uploaden {progress}",
	"required-if-greater-than-or-equal": "{property} is vereist wanneer {compareSource} is groter dan of gelijk zijn aan {compareValue}.",
	"powered-by-cognito": "Aangedreven door Cognito Forms.",
	"form-name-default": "Untitled",
	"field-choice-defaults": "Eerste keuze|Tweede keuze|Derde keuze",
	"additional-fee-default-label": "Betaling",
	"authenticated-save-and-resume-email-dialog": "Stuur een link per e-mail en ga terug naar het formulier om uw inzending te voltooien.",
	"string-length-between": "{property} moet tussen {min} en {max} tekens.",
	"update-button-text": "Update",
	"address-zip-code-invalid": "Zip Code moet worden geformatteerd zoals #####-####.",
	"required-if-greater-than": "{property} is vereist wanneer {compareSource} is groter dan {compareValue}.",
	"compare-before": "{property} moet zijn voordat {compareSource}.",
	"compare-after": "{property} moet na {compareSource}.",
	"unsupported-browser-message": "Oh No! U gebruikt een niet-ondersteunde browser. {a}Klik hier{/a} als u wilt upgraden.",
	"shared-entry-email-subject": "Gedeelde Koppeling",
	"send-button-text": "Sturen",
	"venmo-help-text": "Maak verbinding met Venmo om door te gaan met betalen.",
	"field-repeatingsection-item-label": "Item",
	"save-and-resume-email-not-sent-message": "Er was een probleem.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} moet minstens {min} zijn.",
	"entry-notification-full-entry-detail-link": "Volledige vermelding details op cognitoforms.com bekijken.",
	"element-label-website": "Website",
	"element-label-signature": "Handtekening",
	"paypal-help-text": "Maak verbinding met PayPal om door te gaan met betalen.",
	"card-on-file-agreement-validation": "U moet ermee akkoord gaan om uw kaart te bewaren voor toekomstige transacties.",
	"marketing-button-4": "Bouw Je Eigen Gratis",
	"field-datepicker-now": "Nu",
	"save-and-resume-email-resume-button": "Ga nu door",
	"field-datepicker-next-month": "Volgende maand",
	"quantity-remaining-text": "overig",
	"payment-declined": "Betaling geweigerd",
	"required-if-before": "{property} is vereist wanneer {compareSource} is voor {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} moet minder dan {compareSource} zijn.",
	"entry-admin-link": "",
	"required-many": "{0} zijn vereist.",
	"save-and-resume-multiple-days-expiration-email-message": "Kopiëren of e-mail de onderstaande link en terug te keren naar uw formulier binnen de komende {days} dagen om uw inzending te voltooien.",
	"string-length-at-least": "{property} moet minstens {min} tekens.",
	"credit-card-number": "Credit cardnummer",
	"range-on-or-before": "{property} moet op of vóór {max}.",
	"required-one": "{0} is vereist.",
	"fileupload-max-file-count-exceeded-message": "Alleen {maxFileCount} bestanden kunnen worden geüpload.",
	"order-transaction-details-header": "Transactiedetails",
	"field-spinner-increase": "Toenemen",
	"payment-processing-fees": "Verwerking van vergoedingen",
	"payment": "Betaling",
	"field-choice-other-fill-in": "Andere",
	"shared-entry-email-message": "Een vermelding is met u gedeeld.",
	"shared-entry-workflow-link": "Bekijk het formulier.",
	"required-if-exists": "{property} is vereist wanneer {compareSource} is opgegeven.",
	"concurrent-conflict-toast-message": "Verzenden mislukt omdat de formulierinformatie is gewijzigd. Controleer en probeer het opnieuw.",
	"secured-by-paypal": "Beveiligd door ",
	"range-on-or-after": "{property} moet op of na {min}.",
	"payment-amount-due": "Verschuldigde bedrag",
	"required-name-first-and-last": "Voornaam en Achternaam zijn vereist.",
	"required": "{property} is vereist.",
	"string-format-alphabetic": "{property} moet alleen letters bevatten.",
	"quantity-limit": "{property} hoeveelheid overschreden.",
	"field-spinner-decrease": "Verminderen",
	"field-repeatingsection-add-link-text": "Toevoegen",
	"fileupload-max-size-exceeded-message": "Alleen bestanden die kleiner zijn dan {maxSize} MB kunnen worden geüpload.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Niet Meegenomen",
	"field-ratingscale-satisfied-unsatisfied-label": "Tevreden/Ontevreden",
	"range-between": "{property} moet tussen {min} en {max}.",
	"field-ratingscale-agree-disagree-label": "Eens/Oneens",
	"back-button-text": "Terug",
	"address-country": "Land",
	"order-not-found": "Geen bestellingsinformatie gevonden.",
	"field-ratingscale-satisfied-unsatisfied-options": "Zeer ontevreden|Ontevreden|Neutraal|Tevreden|Zeer tevreden",
	"entry-notification-entry-details-header": "Vermelding details",
	"FALSE": "ONWAAR",
	"compare-greater-than-or-equal": "{property} moet groter dan of gelijk zijn aan {compareSource}.",
	"receipt-notification-order-details-desc-header": "Beschrijving",
	"order-method-label": "Methode",
	"order-total-label": "Ordertotaal",
	"invalid-shared-link": "Ongeldige Gedeeld Link",
	"fileupload-zero-byte-file-message": "Nulbyte bestanden kunnen niet worden geüpload.",
	"range-at-most": "{property} mag maximum {max} zijn.",
	"format-integer": "####",
	"order-date-label": "Datum",
	"fileupload-dropzone-message": "of bestanden hierheen slepen.",
	"shared-entry-view-link": "Bekijk de gedeelde toegang.",
	"format-currency": "€ #.###,##",
	"string-length-at-most": "{property} moet hoogstens {max} tekens bestaan.",
	"entry-confirmation-footer-tagline": "Maak uw eigen krachtige betaalformulieren met",
	"submit-button-text": "Verstuur",
	"marketing-msg": "Maak eenvoudig krachtige formulieren.",
	"required-if-on-or-after": "{property} is vereist wanneer {compareSource} is op of na {compareValue}.",
	"card-on-file-agreement": "Ik ga ermee akkoord mijn kaart te bewaren voor toekomstige transacties.",
	"signature-draw": "tekenen",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} moet op of na {compareSource}.",
	"required-if-less-than-or-equal": "{property} is vereist wanneer {compareSource} is kleiner dan of gelijk aan {compareValue}.",
	"field-datepicker-next-year": "Volgend jaar",
	"change-button": "veranderen",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Kaart",
	"order-billing-info-header": "Facturatiegegevens",
	"entry-email-view-details-text": "Volledige vermelding details op cognitoforms.com bekijken.",
	"save-and-resume-one-day-expiration-email-message": "Kopiëren of e-mail de onderstaande link en terug te keren naar uw formulier binnen de volgende dag om uw inzending te voltooien.",
	"credit-card-authentication-failed": "Card failed authentication.",
	"compare-less-than-or-equal": "{property} moet kleiner dan of gelijk zijn aan {compareSource}.",
	"receipt-notification-order-details-balance-due": "Resterend bedrag",
	"save-and-resume-multiple-days-expiration-message": "Gebruik onderstaande knop om terug te keren naar het formulier. Je hebt {days} dagen om het formulier af te ronden en te versturen.",
	"processing-fee-calculating-message": "Berekening",
	"receipt-notification-trx-details-method": "Methode",
	"field-choice-no-match": "Geen overeenkomende resultaten",
	"fileupload-invalid-file-type-message": "Alleen {allowedTypes} bestanden kunnen worden geüpload.",
	"receipt-notification-trx-details-date": "Datum",
	"credit-card-authorization": "Kaartautorisatie",
	"address-line1": "Adresregel 1",
	"required-if-not-exists": "{property} is vereist wanneer {compareSource} is niet opgegeven.",
	"required-if-not-equal": "{property} is verplicht als {compareSource} is niet {compareValue}.",
	"marketing-button-2": "Bouw Je Eigen Gratis",
	"receipt-notification-billing-info-header": "Facturatiegegevens",
	"required-if-after": "{property} is vereist wanneer {compareSource} is na {compareValue}.",
	"element-label-name": "Naam",
	"required-if-equal": "{property} is verplicht als {compareSource} gelijk is aan {compareValue}.",
	"connected-to-paypal": "Verbonden met PayPal.",
	"people-form-email-quantity-exceeded-message": "E-mailadres moet uniek zijn.",
	"receipt-notification-order-details-subtotal": "Subtotaal",
	"shared-entry-edit-link": "Bewerk de gedeelde toegang.",
	"receipt-notification-trx-details-header": "Transactiedetails",
	"address-city": "Plaats",
	"receipt-notification-order-details-amount-paid": "Betaald bedrag",
	"credit-card-invalid": "Kaart is ongeldig.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "U heeft een nieuwe inschrijving op uw formulier.",
	"this-and-that": "{0} en {1}",
	"field-ratingscale-good-poor-label": "Goed/Slecht",
	"network-unavailable-message": "Netwerk niet beschikbaar. Probeer het later opnieuw.",
	"dialog-close": "Sluiten",
	"string-format-alphanumeric": "{property}  mag alleen letters en cijfers bevatten.",
	"credit-card": "Credit card",
	"remove-item": "Verwijderen {item}",
	"receipt-notification-order-details-price-header": "Prijs",
	"fileupload-upload-inprogress-message": "Bestandsupload in voortgang.",
	"public-terms-of-service-link-text": "Servicevoorwaarden",
	"save-and-resume-email-subject": "Opslaan \u0026 Hervatten Link",
	"field-repeatingsection-remove-link-text": "Verwijderen",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Toevoegen {item}",
	"field-toggle-options": "Ja/Nee|Waar/Onwaar|Open/Gesloten|Actief/Inactief|Gelezen/Ongelezen",
	"order-submit-timeout": "Orderverwerking duurt te lang. Probeer uw bestelling later.",
	"listlength-at-most": "Geef aub niet meer dan {max} {property}.",
	"shared-entry-email-view-message": "Gebruik de link hieronder om de gedeelde toegang bekijken.",
	"order-number-label": "Nummer",
	"card-declined": "Kaart geweigerd",
	"fileupload-default-upload-button-text": "Uploaden",
	"name-prefix": "Titel",
	"address-line2": "Adresregel 2",
	"element-label-email": "E-mail",
	"field-ratingscale-good-poor-options": "Zeer slecht|Slecht|Gemiddeld|Goed|Zeer goed",
	"next-button-text": "Volgende",
	"question": "Vraag",
	"address-postalcode": "Postcode / Zip Code",
	"format-with-description": "{property} moet worden geformatteerd zoals {description}.",
	"field-datepicker-prev-month": "Vorige maand",
	"name": "Naam",
	"receipt-notification-order-details-total-footer": "Totaal",
	"confirmation-message": "Dank u voor het invullen van het formulier. Uw antwoord is opgenomen.",
	"shared-entry-email-edit-message": "Gebruik de link hieronder om de gedeelde toegang bewerken.",
	"field-default-label": "Untitled",
	"required-value": "{property} moet {value} zijn.",
	"name-middle": "Initialen",
	"fileupload-failed-upload-message": "{fileName} is mislukt om te uploaden.",
	"shared-entry-email-button-label": "Bekijk het item",
	"field-datepicker-year": "",
	"element-label-phone": "Telefoon",
	"TRUE": "WAAR",
	"listlength-between": "Gelieve te specificeren tussen de {min} en {max} {property}.",
	"marketing-button-1": "Probeer Het Nu",
	"entry-submission-error-heading": "Fout verwerking vermelding",
	"order-not-found-message": "Geen bestellingsinformatie gevonden.",
	"format-without-description": "{property} is niet juist geformatteerd.",
	"name-last": "Achternaam",
	"field-ratingscale-one-five-label": "Schaal van 1 tot 5",
	"listlength-at-least": "Geef aub minimaal {min} {property}.",
	"united-states": "Verenigde Staten",
	"field-signature-captured": "Geregistreerd",
	"compare-on-or-before": "{property} moet op of vóór {compareSource}.",
	"order-balance-due-label": "Due in evenwicht",
	"required-if-less-than": "{property} is vereist wanneer {compareSource} is minder dan {compareValue}.",
	"credit-card-postalcode": "Postcode",
	"form-not-available-message": "Dit formulier is momenteel niet beschikbaar.",
	"element-label-address": "Adres",
	"receipt-notification-trx-details-number": "Nummer",
	"public-submission-warning": "Stuur geen wachtwoorden via Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Kopiëren of e-mail de onderstaande link en terugkeren naar uw formulier om uw inzending te voltooien.",
	"fileupload-excluded-file-type-message": "Bestanden van dit type kunnen niet worden geüpload.",
	"payment-subtotal": "Subtotaal",
	"collapse": "Samenvouwen",
	"save-button-text": "Opslaan",
	"field-datepicker-prev-year": "Vorig jaar",
	"signature-type": "typen",
	"order-amount-minimum": "Verschuldigd bedrag moet op zijn minst € 1,00 zijn.",
	"string-format-numeric": "{property} mag alleen cijfers bevatten.",
	"entry-confirmation-entry-details-header": "Vermelding details",
	"connected-to-venmo": "Verbonden met Venmo.",
	"format-percentage": "#,##%",
	"receipt-notification-header": "Ontvangstbewijs",
	"clear": "Verwijder",
	"today": "Vandaag",
	"required-name-last": "Achternaam is vereist.",
	"marketing-button-3": "Probeer Het Nu",
	"expand": "Uitbreiden",
	"compare-greater-than": "{property} moet groter zijn dan {compareSource}.",
	"field-ratingscale-will-wont-label": "Wel/Niet",
	"required-name-first": "Voornaam is vereist.",
	"save-and-resume-one-day-expiration-message": "Kopieer of e-mail de onderstaande link om terug te keren naar uw formulier binnen de volgende dag en uw inzending te voltooien.",
	"required-asterisk": "is vereist",
	"credit-card-required": "Er is een creditcard vereist.",
	"address-state-province-region": "Staat / Provincie / Regio",
	"save-and-resume-email-sent-message": "De e-mail is verzonden.",
	"workflow-action": "Actie",
	"field-ratingscale-will-wont-options": "Zeker niet|Waarschijnlijk niet|Niet zeker|Waarschijnlijk|Zal wel",
	"save-and-resume-email-label": "E-mail mij mijn link:",
	"field-ratingscale-agree-disagree-options": "Helemaal oneens|Oneens|Neutraal|Mee eens|Helemaal mee eens",
	"order-exception-order-already-paid": "Deze bestelling is al betaald.",
	"fileupload-download-text": "Download",
	"address-state": "Staat",
	"allowed-values": "{property} is niet in de lijst met toegestane waarden.",
	"shared-entry-workflow-email-button-label": "Open het formulier",
	"compare-equal": "{property} moet hetzelfde zijn als {compareSource}.",
	"field-datepicker-clear": "Legen",
	"name-first": "Voornaam",
	"save-and-resume-message": "Uw vooruitgang is opgeslagen.",
	"save-and-resume-no-expiration-message": "Kopieer of e-mail de onderstaande link om terug te keren naar uw formulier en uw inzending te voltooien.",
	"entry-notification-view-details-text": "Bekijk details",
	"order-exception-default-message": "Kan de transactie niet verwerken.",
	"public-report-abuse-link-text": "Meld misbruik",
	"order-amount-paid": "Betaald bedrag",
	"element-label-default": "Untitled",
	"countries": "Afghanistan|Albanië|Algerije|Amerikaans-Samoa|Andorra|Angola|Anguilla|Antarctica|Antigua en Barbuda|Argentinië|Armenië|Aruba|Australië|Azerbeidzjan|Bahama \u0027s|Bahrein|Bangladesh|Barbados|België|Belize|Benin|Bermuda|Bhutan|Birma, Myanmar|Bolivia|Bosnië-Herzegovina|Botswana|Brazilië|Brunei Darussalam|Bulgarije|Burkina Faso|Burundi|Cambodja|Canada|Cape Verde|Cayman eilanden|Centraal-Afrikaanse Republiek|Chili|China|Christmaseiland|Cocos (Keeling) eilanden|Colombia|Comoren|Congo, Republiek of(Brazzaville)|Cookeilanden|Costa Rica|Cuba|Cyprus|Democratische Republiek Congo (Kinshasa)|Denemarken|Djibouti|Dominica|Dominicaanse Republiek|Duitsland|Ecuador|Egypte|El Salvador|Equatoriaal-Guinea|Eritrea|Estland|Ethiopië|Faeröereilanden|Falkland eilanden|Fiji|Filippijnen|Finland|Frankrijk|Frans Zuidelijk Terrotorium|Frans-Guyana|Frans-Polynesië|Gabon|Gambia|Georgië|Ghana|Gibraltar|Grenada|Griekenland|Groenland|Groot-Brittannië|Guadeloupe|Guam|Guatemala|Guinea|Guinee-Bissau|Guyana|Haïti|Heilige stoel|Honduras|Hong Kong|Hongarije|Ierland|IJsland|India|Indonesië|Irak|Iran (Islamic Republic of)|Israël|Italië|Ivoorkust|Jamaica|Japan|Jemen|Jordanië|Kameroen|Kazachstan|Kenia|Kirgizië|Kiribati|Koeweit|Korea, democratische \u0027 s Rep. (Noord Korea)|Korea, Republiek van (Zuid Korea)|Kosovo|Kroatië|Lao, mensen \u0027 s Democratische Republiek|Lesotho|Letland|Libanon|Liberia|Libië|Liechtenstein|Litouwen|Luxemburg|Macau|Republiek Macedonië|Madagaskar|Malawi|Maldiven|Maleisië|Mali|Malta|Man|Marokko|Marshall eilanden|Martinique|Mauritanië|Mauritius|Mayotte|Mexico|Micronesia, Federale Staten van|Moldova, Republiek van|Monaco|Mongolië|Montenegro|Montserrat|Mozambique|Namibië|Nauru|Nederland|Nederlandse Antillen|Nepal|Nicaragua|Nieuw-Caledonië|Nieuw-Zeeland|Niger|Nigeria|Niue|Noorwegen|Northern Mariana Islands|Oeganda|Oekraïne|Oezbekistan|Oman|Oostenrijk|Oost-Timor (Oost-Timor)|Pakistan|Palau|Palestijnse gebieden|Panama|Papoea-Nieuw-Guinea|Paraguay|Peru|Pitcairn Island|Polen|Portugal|Puerto Rico|Qatar|Réunion Eiland|Roemenië|Russische Federatie|Rwanda|Saint Kitts en Nevis|Saint Lucia|Saint Vincent en de Grenadines|Samoa|San Marino|Sao Tome en Principe|Saudi-Arabië|Senegal|Servië|Seychellen|Sierra Leone|Singapore|Slovenië|Slowakije (Slowaakse Republiek)|Soedan|Solomon Islands|Somalië|Spanje|Sri Lanka|Suriname|Swaziland|Syrië, Arabische Republiek Syrië|Tadzjikistan|Taiwan (Republiek China)|Tanzania; officieel de Verenigde Republiek Tanzania|Thailand|Tibet|Timor-Leste (Oost-Timor)|Togo|Tokelau-eilanden|Tonga|Trinidad enTobago|Tsjaad|Tsjechische Republiek|Tunesië|Turkije|Turkmenistan|Turks and Caicos Islands|Tuvalu|Uruguay|Vanuatu|Vaticaanstad (Heilige stoel)|Venezuela|Verenigd Koninkrijk|Verenigde Staten|Verenigde Arabische Emiraten|Vietnam|Virgin eilanden (VS)|Virgin Islands (British)|Wallis en Futuna|Westelijke Sahara|Wit-Rusland|Zambia|Zimbabwe|Zuid-Afrika|Zuid-Soedan|Zweden|Zwitserland",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Order moet ten minste 1 line item bevatten.",
	"compare-not-equal": "{property} moet verschillen van {compareSource}.",
	"entry-notification-footer": "U ontvangt deze e-mail omdat u de optie \"e-mail van berichten ontvangen\" op uw formulier inCognito Forms heeft geselecteerd.",
	"save-and-resume-copy-link-label": "Kopieer uw formulier link:",
	"entry-confirmation-footer": "U ontvangt deze e-mail, omdat u een transactie heeft voltooid [Name].",
	"required-if-on-or-before": "{property} is vereist wanneer {compareSource} is op of vóór {compareValue}.",
	"string-format": "{property} moet worden geformatteerd zoals {formatDescription}.",
	"switch-to-drawing-mode": "Schakel over naar tekenmodus vanuit typemodus.",
	"switch-to-typing-mode": "Schakel over naar typemodus vanuit tekenmodus."
};
